'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import { INPUT_SIZE_OPTIONS, USE_CLASSES } from './InputConstants';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import ShareInput from '../decorators/ShareInput';
import refObject from '../utils/propTypes/refObject';
import { FieldsetContext } from '../context/FieldsetContext';
const TYPES = ['text', 'email', 'number', 'password', 'search', 'url', 'tel'];

class UITextInput extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      className,
      error,
      inputRef,
      placeholder,
      styled,
      use
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["className", "error", "inputRef", "placeholder", "styled", "use"]);

    const {
      size: fieldSize
    } = this.context;
    return /*#__PURE__*/_jsx("input", Object.assign({}, rest, {
      className: classNames('form-control private-form__control', INPUT_SIZE_OPTIONS[fieldSize], className, USE_CLASSES[use], !styled && 'private-form__control--unstyled uiTextInputUnstyled', error && 'private-form__control--error'),
      placeholder: lazyEval(placeholder),
      ref: inputRef
    }));
  }

}

UITextInput.contextType = FieldsetContext;
UITextInput.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  inputRef: refObject,
  onChange: PropTypes.func,
  placeholder: createLazyPropType(PropTypes.string),
  readOnly: PropTypes.bool,
  styled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(TYPES),
  use: PropTypes.oneOf(Object.keys(USE_CLASSES)),
  value: PropTypes.string
};
UITextInput.defaultProps = {
  error: false,
  styled: true,
  type: 'text'
};
UITextInput.displayName = 'UITextInput';
export default ShareInput(UITextInput);